import { render, staticRenderFns } from "./staff-data.vue?vue&type=template&id=7c7dff22&scoped=true&"
import script from "./staff-data.vue?vue&type=script&lang=js&"
export * from "./staff-data.vue?vue&type=script&lang=js&"
import style0 from "./staff-data.vue?vue&type=style&index=0&id=7c7dff22&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7dff22",
  null
  
)

export default component.exports